import React from "react";
import styles from "./MySpinner.module.scss"; // Adjust path to your CSS module

const MySpinner: React.FC = () => {
  return (
    <div className={styles.spinner}>
      <div className={styles.spinnerInner}></div>
    </div>
  );
};

export default MySpinner;
